import { Link } from "react-router-dom";
import { LegalFooter } from "@/components/LegalFooter";
import { TERMINOS_HTML, TERMINOS_TITLE } from "@/legal/terminos";
import { PRIVACIDAD_HTML, PRIVACIDAD_TITLE } from "@/legal/privacidad";

const DOCS = {
  terminos: { title: TERMINOS_TITLE, html: TERMINOS_HTML },
  privacidad: { title: PRIVACIDAD_TITLE, html: PRIVACIDAD_HTML },
} as const;

export default function LegalPage({ kind }: { kind: keyof typeof DOCS }) {
  const doc = DOCS[kind];
  return (
    <main className="min-h-screen bg-slate-50 px-5 py-14 sm:px-10" data-testid={`legal-page-${kind}`}>
      <div className="mx-auto max-w-3xl">
        <Link to="/" className="eyebrow" data-testid="legal-home-link">Otium</Link>
        <h1 className="mt-2 font-display text-3xl font-extrabold tracking-tight text-[#1B2A4A] sm:text-4xl" data-testid="legal-title">{doc.title}</h1>
        <article className="legal-prose mt-8 rounded-[14px] border border-[#DDE1E8] bg-white p-6 sm:p-10" data-testid="legal-content"
          dangerouslySetInnerHTML={{ __html: doc.html }} />
        <LegalFooter className="mt-10" />
      </div>
    </main>
  );
}
